<template>
    <div class="">
        <div class="form-inline">
            <div class="form-group btn-group">
                <!--<div class="form-group">
                    <input type="text" v-model="filterText" class="form-group form-inline" @keyup.enter="doFilter" placeholder="Digite o nome do Usuário">
                    <button class="btn btn-sm btn-primary" @click.prevent="doFilter"><i class="fa fa-search"></i></button>
                    <button class="btn btn-sm" @click.prevent="resetFilter"><i class="fa fa-history"></i></button>
                </div>-->
                <div class="btn-group">
                    <button class="btn btn-primary" @click="getModalParametros" v-if="admin > 0">Parametros</button>
                    <button class="btn btn-primary" @click="novaRota">Nova Rota</button>
                    <button class="btn btn-primary" @click="mydiario"><i class="fa fa-bookmark"></i> Diário</button>
                    <button class="btn btn-primary" @click="linkDespesa"><i class="fas fa-dollar-sign"></i> Listar Despesas</button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from "vue-bootstrap-datetimepicker/src/component";


    export default {
        components: {DatePicker},
        data() {
            return {
                filterText: '',
                admin: $('#Admin').val(),
                km_dia:0,
                valor_hospedagem:0,
                valor_alimentacao:0,
                km_extra:0,
                searchFile:'lote',
                codigolote: '',
                km_litro:0,
                valor_combustivel:0,
                fromDate: '',
                toDate: '',
                datePickerConfig: {
                    'format': 'D/MM/YYYY',
                    'showClose': true
                },
            }
        },
        methods: {

            searchTo(campo){
                this.searchFile = campo;
                return;
            },

            doFilter() {

                this.$events.fire('filter-set', this.filterText);

            },
            changeStatus(status) {
                this.$events.fire('filter-status', status);
            },

            resetFilter() {

                    this.fromDate = '';
                    this.toDate = '';
                    this.$events.fire('filter-reset');
            },
            initDate(){
                let m = moment();

                m.set({hour:0,minute:0,second:0,millisecond:0});

                this.toDate = moment();
                this.toDate.set({hour:0,minute:0,second:0,millisecond:0});

                this.fromDate = m;
                if(this.isDistribuidor){
                    this.fromDate.subtract(1,'month');
                }else{
                    this.fromDate.subtract(5,'day');
                }
            },
            getModalParametros:function(){
                this.$events.fire('get-parametros');

            },
            novaRota:function(){
                window.location.href='/adm/rotas/create'
            },
            linkDespesa:function(){
                $('.loading').show();
                window.location.href='/adm/despesas';
            },
            mydiario:function(){
                $('.loading').show();
                window.location.href='/adm/rotas/diario';
            },


        },
        computed:{
        },
        mounted: function () {

        },
    }
</script>
<style>
    .filter-bar {
        padding: 10px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/rotas/table/Rotas.vue